import React from 'react';
import TeamAvailable from '../../common/components/images/team-available.png';
import Image from '../Image';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const LoadingDefy = (props) => {
    const { handlerNext } = props;
    return (
        <div className=''>
            <div className="w-full md:pt-12 pt-8 flex text-center justify-center content-center items-center">
                <div className={`relative flex justify-center`}>
                    <Image
                        imgClassName={`rounded-3xl p-0 m-0 md:w-[172px] md:h-[200px] w-[240px]`}
                        className={`block md:w-full w-3/6`}
                        minWidth={null}
                        key={`img-incognito`}
                        src={TeamAvailable}
                        alt="Incógnito"
                    />
                </div>
            </div>
            <div className="flex justify-center items-center mt-8 md:pt-[70px] pt-[70px] md:px-0 px-2 md:pb-[80px] pb-[40px]">
                <div className=" flex justify-center items-center text-sm-defy-green font-bold text-lg  md:text-2xl pt-6 md:pt-0">
                    <button
                        className="border border-sm-defy-green shadow rounded-xl p-4 md:max-w-sm md:w-full md:mx-auto cursor-pointer hover:shadow-2xl sport-zoom"
                        type="button"
                        onClick={() => handlerNext()}
                    >
                        <div className="animate-pulse flex md:space-x-4">
                            <div className="rounded-full bg-sm-defy-green h-16 md:h-6 w-12"></div>
                            <p className="pl-1 animate-pulse text-sm-defy-green"> Reservar cupo</p>
                            <div className="flex-1 space-y-4 py-1">
                                <div className="h-4 bg-sm-defy-green rounded w-3/4"></div>
                            </div>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LoadingDefy;
